import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Xmark, WarningTriangle } from 'iconoir-react';

interface StorageWarningToastProps {
  usedMb: number;
  limitMb: number;
  onClose: () => void;
}

const formatStorage = (mb: number): string => {
  if (mb >= 1024) return `${(mb / 1024).toFixed(mb % 1024 === 0 ? 0 : 1)} Go`;
  return `${Math.round(mb)} Mo`;
};

export const StorageWarningToast: React.FC<StorageWarningToastProps> = ({ usedMb, limitMb, onClose }) => {
  const navigate = useNavigate();

  const handleAddStorage = () => {
    onClose();
    navigate('/account', { state: { activeTab: 'overages' } });
  };

  return (
    <div className="storage-warning-toast">
      <WarningTriangle width={20} height={20} strokeWidth={2} color="#ff4d4d" />
      <div className="storage-warning-toast-body">
        <strong>Espace de stockage presque plein</strong>
        <p>Vous utilisez {formatStorage(usedMb)} sur {formatStorage(limitMb)}.</p>
        <button className="btn btn-primary" onClick={handleAddStorage}>
          Ajouter du stockage
        </button>
      </div>
      <button className="storage-warning-toast-close" onClick={onClose} title="Fermer">
        <Xmark width={16} height={16} strokeWidth={2} />
      </button>
    </div>
  );
};
